import React from 'react';
import '../../../styles/parentPortal.css';

const VARIANTS = {
  primary: {
    background: 'var(--btn-primary-bg)',
    color: 'var(--btn-primary-text)',
    border: '1px solid transparent',
  },
  secondary: {
    background: 'var(--btn-secondary-bg)',
    color: 'var(--btn-secondary-text)',
    border: '1px solid var(--btn-secondary-border)',
  },
  danger: {
    background: 'var(--danger)',
    color: 'var(--btn-danger-text)',
    border: '1px solid transparent',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--text-primary)',
    border: '1px solid transparent',
  },
};

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  style,
  ...rest
}) {
  const v = VARIANTS[variant] || VARIANTS.primary;
  const padY = size === 'sm' ? 'var(--space-2)' : 'var(--space-3)';
  const padX = size === 'sm' ? 'var(--space-3)' : 'var(--space-4)';
  const fontSize = size === 'sm' ? 13 : 14;
  return (
    <button
      className="pp-btn"
      disabled={disabled || loading}
      style={{
        padding: `${padY} ${padX}`,
        fontSize,
        fontWeight: 600,
        borderRadius: 'var(--radius-control)',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        opacity: disabled || loading ? 0.6 : 1,
        transition: 'background var(--transition-fast), opacity var(--transition-fast), box-shadow var(--transition-fast)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-2)',
        ...v,
        ...style,
      }}
      {...rest}
    >
      {loading && (
        <span
          aria-hidden="true"
          style={{
            width: 14,
            height: 14,
            border: '2px solid currentColor',
            borderRightColor: 'transparent',
            borderRadius: '50%',
            animation: 'graspd-spin 0.7s linear infinite',
            display: 'inline-block',
          }}
        />
      )}
      <span>{children}</span>
    </button>
  );
}
